import React from 'react';
import { useLocation } from 'react-router';
import styled, { css } from 'styled-components';
import BlockLink from './BlockLink';

const ListItem = styled.li<{ route: string; pathname: string }>`
  ${({ route, pathname, theme }) => {
    const match = route === pathname || `/${pathname.split('/')[1]}` === route;
    return css`
      padding: 15px 30px;
      border-radius: 25px;
      background-color: ${match && theme.colors.greyLightest};
      color: ${match ? theme.colors.black : theme.colors.sideBarLI};

      svg {
        margin-right: 10px;
        &:hover {
          cursor: pointer;
        }
      }
    `;
  }}
`;

const StyledLink = styled(BlockLink)`
  display: flex;
  align-items: center;
  padding: 0;
`;

interface SideBarOptionProps {
  option: {
    name: string;
    route: string;
    icon: React.ReactNode;
    permission?: string;
  };
}

const SideBarOption = ({
  option: { name, route, icon },
}: SideBarOptionProps) => {
  const { pathname } = useLocation();
  return (
    <ListItem route={route} pathname={pathname}>
      <StyledLink to={route}>
        {icon}
        {name}
      </StyledLink>
    </ListItem>
  );
};

export default SideBarOption;
